export const environment = {
  production: true,
  AZURE_REDIRECT:'https://ads-stflabs-corporativo-frontend-web.apps.stefanini.io/login/',
  AZURE_PROJECT:'Pesquisaio',
  AZURE_ENVIRONMENT:'P',
  API_URL: 'https://pesquisacandidato-api.apps.stefanini.io',
  defaultDebounceTime: 500
};
